import { ButtonGroup, HStack, Text } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { EventPanelFormType } from '@mark43/cad-api';
import { FormButton } from '../../forms/integrated-form-components/form-button';
import { useIntegratedForm } from '../../forms/use-integrated-form';
import { FormSaveButton } from '../../forms/integrated-form-components/form-save-button';
import { useSubmitEventForm } from '../../common/hooks/use-submit-event-form';

export const EventWithDirtyFieldsFooter = observer(
    function ActiveEventWithDirtyFieldsFooter(props: { dirtyFieldCount: number }) {
        const eventForm = useIntegratedForm<EventPanelFormType>();
        const { dirtyFieldCount } = props;
        const submitEventForm = useSubmitEventForm();

        return (
            <HStack w="100%" justifyContent="space-between">
                <Text
                    variant="caption"
                    style={{
                        color: 'var(--arc-colors-text-tertiary)',
                    }}
                >
                    {dirtyFieldCount} unsaved changes
                </Text>
                <ButtonGroup style={{ flex: 1, justifyContent: 'flex-end' }}>
                    <FormButton
                        variant="ghost"
                        onClick={() => {
                            eventForm.form.reset();
                        }}
                    >
                        Cancel
                    </FormButton>
                    <FormSaveButton onClick={submitEventForm}>Save</FormSaveButton>
                </ButtonGroup>
            </HStack>
        );
    }
);
